/**
 * @enum {string}
 */
var _ol_interaction_Property_ = {
  ACTIVE: 'active'
};

export default _ol_interaction_Property_;



//////////////////
// WEBPACK FOOTER
// C:/Users/user/projects/ansyn/node_modules/ol/interaction/property.js
// module id = ../../../../ol/interaction/property.js
// module chunks = vendor